import { render } from "./LoadedOrderList.vue?vue&type=template&id=4c690733"
import script from "./LoadedOrderList.vue?vue&type=script&lang=js"
export * from "./LoadedOrderList.vue?vue&type=script&lang=js"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__